import { db } from "../../firebase";
import { collection, getDocs } from "firebase/firestore";

export const getCompleteCollection = async () => {
  try {
    let dynamicFieldsCollection = await collection(db, "dynamicFields");
    dynamicFieldsCollection = (await getDocs(dynamicFieldsCollection)).docs;
    return dynamicFieldsCollection.map((e) => [e.id, e.data()]);
  } catch (error) {
    console.log(error);
    return false;
  }
};
